import React from "react";

export const Icons = ({
  icon = "github",
  color = null,
  intensity = 500,
  size = 5,
}) => {
  let colorClass = " text-" + color + "-" + intensity;
  let sizeClass = " h-" + size + " w-" + size + " ";

  if (icon.toLowerCase() === "cart" || icon.toLowerCase() === "catalog") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className="mr-1 inline h-4 w-4 transition duration-100 "
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M7.441 7h-2.882l4.701-4.702c.198-.198.459-.298.72-.298.613 0 1.02.505 1.02 1.029 0 .25-.092.504-.299.711l-3.26 3.26zm9.118 0h2.883l-4.702-4.702c-.198-.198-.459-.298-.72-.298-.613 0-1.02.505-1.02 1.029 0 .25.092.504.299.711l3.26 3.26zm-16.559 2v2h.643c.577 0 1.061.299 1.343 1h20.03c.28-.699.766-1 1.343-1h.641v-2h-24zm21.213 5h-18.425l1.204 3h16.016l1.205-3zm-16.417 5l1.204 3h12l1.205-3h-14.409z" />
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "logot") {
    return (
      <span>
        <svg
          className={
            " mr-1 inline transition duration-100 " + colorClass + sizeClass
          }
          viewBox="0 0 100 122"
          fill="currentColor"
          version="1.1"
        >
          <g
            id="elections"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Group-2"
              transform="translate(0.000000, 0.000000)"
              fillRule="nonzero"
            >
              <path
                d="M8.63561694,40.1515152 C6.37178072,33.9813305 3.59092257,27.0186107 0.292164708,19.2664405 C-0.571915859,17.2352414 0.55618384,14.9071667 2.68130633,14.3356248 L24.990495,8.33333333 C26.7786535,21.3545293 27.7902258,31.9882049 28.030303,40.1515152 L8.63561694,40.1515152 Z"
                id="Path"
                fill="currentColor"
              ></path>
              <path
                d="M71.969697,40.1515152 C72.2097308,31.9888659 73.2212391,21.3545293 75.0095107,8.33333333 L97.3187416,14.3356248 C99.4438022,14.9071226 100.57186,17.2351973 99.7078877,19.2664405 C96.409343,27.0186107 93.6284796,33.9813305 91.3644197,40.1515152 L71.969697,40.1515152 Z"
                id="Path"
                fill="currentColor"
              ></path>
              <path
                d="M84.8484848,82.5757576 L15.9090909,82.5757576 C15.951181,81.3969296 15.9717962,80.219046 15.9717962,79.0400463 L15.9717962,71.969697 L84.7857796,71.969697 L84.7857796,79.0400463 C84.7857796,80.2188743 84.8063947,81.3967579 84.8484848,82.5757576 L84.8484848,82.5757576 Z"
                id="Path"
                fill="currentColor"
              ></path>
              <path
                d="M85.3891535,90.1515152 C86.0325425,96.4110844 87.2324314,102.675049 88.9889083,108.943408 C90.607697,114.718852 87.2290624,120.710757 81.4421506,122.325534 C80.488264,122.592496 79.5016784,122.727273 78.5109091,122.727273 L22.2443729,122.727273 C16.2354601,122.727273 11.3636364,117.86602 11.3636364,111.86906 C11.3636364,110.880152 11.4995388,109.895529 11.7661756,108.94365 C13.5225864,102.67551 14.7225194,96.4115459 15.3659304,90.1515152 L85.3891535,90.1515152 Z"
                id="Path"
                fill="currentColor"
              ></path>
              <path
                d="M10.2564271,46.969697 L89.7435729,46.969697 C93.734931,46.969697 96.969697,50.2262277 96.969697,54.2424684 L96.969697,57.8794061 C96.969697,61.8956468 93.734931,65.1515152 89.7435729,65.1515152 L10.2564271,65.1515152 C6.26506901,65.1515152 3.03030303,61.8958676 3.03030303,57.8794061 L3.03030303,54.2424684 C3.03030303,50.2262277 6.26506901,46.969697 10.2564271,46.969697 Z"
                id="Path"
                fill="lightgray"
              ></path>
              <path
                d="M64.5973371,39.3939394 L35.4013414,39.3939394 C35.1452114,30.4071786 33.9646556,18.6295038 31.8554353,4.08787596 C31.5423924,1.93057068 33.2420961,-1.13686838e-13 35.454987,-1.13686838e-13 L64.5450162,-1.13686838e-13 C66.7577304,-1.13686838e-13 68.4576107,1.9305272 68.1445678,4.08787596 C66.0352372,18.6284166 64.8547476,30.4054392 64.5986617,39.3939394 L64.5973371,39.3939394 Z"
                id="Path"
                fill="currentColor"
              ></path>
            </g>
          </g>
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "logo") {
    return (
      <span className="block">
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline transition duration-100 " + colorClass + sizeClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 117 136"
        >
          <g
            id="Designingwithml.com"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <path
              d="M0,0 L78.9880066,0 L80.6118691,0.671587452 C87.4534601,3.50109212 90.7058988,11.3410642 87.8763941,18.1826552 C86.2867876,22.0262389 83.0031146,24.9142322 78.9880066,26 L78.9880066,26 L78.9880066,26 L0,26 L0,0 Z"
              id="Path"
              fill="currentColor"
            ></path>
            <path
              d="M0,36 L105.992453,36 L107.275128,36.3953265 C114.255631,38.5467516 118.170372,45.9496418 116.018946,52.9301446 C114.591289,57.5623147 110.744112,61.0424285 105.992453,62 L105.992453,62 L105.992453,62 L0,62 L0,36 Z"
              id="Path"
              fill="currentColor"
            ></path>
            <path
              d="M0,72 L34.4332282,72 C41.61293,75.0535159 44.9578645,83.3491778 41.9043486,90.5288796 C40.4740767,93.8918638 37.7962125,96.5697281 34.4332282,98 L34.4332282,98 L34.4332282,98 L0,98 L0,72 Z"
              id="Path"
              fill="lightgray"
            ></path>
            <circle
              id="Oval"
              fill="currentColor"
              cx="66"
              cy="85"
              r="13"
            ></circle>
            <circle
              id="Oval"
              fill="currentColor"
              cx="102"
              cy="85"
              r="13"
            ></circle>
            <path
              d="M0,110 L78.9880066,110 L80.6118691,110.671587 C87.4534601,113.501092 90.7058988,121.341064 87.8763941,128.182655 C86.2867876,132.026239 83.0031146,134.914232 78.9880066,136 L78.9880066,136 L78.9880066,136 L0,136 L0,110 Z"
              id="Path"
              fill="currentColor"
            ></path>
          </g>
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "loading") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            "mr-1 inline   animate-spin  transition duration-100" + sizeClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm8 12c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-19 0c0-6.065 4.935-11 11-11v2c-4.962 0-9 4.038-9 9 0 2.481 1.009 4.731 2.639 6.361l-1.414 1.414.015.014c-2-1.994-3.24-4.749-3.24-7.789z" />
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "check") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline h-5 w-5  transition duration-100 " + colorClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M5.48 10.089l1.583-1.464c1.854.896 3.028 1.578 5.11 3.063 3.916-4.442 6.503-6.696 11.311-9.688l.516 1.186c-3.965 3.46-6.87 7.314-11.051 14.814-2.579-3.038-4.301-4.974-7.469-7.911zm14.407.557c.067.443.113.893.113 1.354 0 4.962-4.038 9-9 9s-9-4.038-9-9 4.038-9 9-9c1.971 0 3.79.644 5.274 1.723.521-.446 1.052-.881 1.6-1.303-1.884-1.511-4.271-2.42-6.874-2.42-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11c0-1.179-.19-2.313-.534-3.378-.528.633-1.052 1.305-1.579 2.024z" />
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "video") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline transition duration-100 " + colorClass + sizeClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M16 16c0 1.104-.896 2-2 2h-12c-1.104 0-2-.896-2-2v-8c0-1.104.896-2 2-2h12c1.104 0 2 .896 2 2v8zm8-10l-6 4.223v3.554l6 4.223v-12z" />
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "text") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline transition duration-100 " + colorClass + sizeClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M24 20v1h-4v-1h.835c.258 0 .405-.178.321-.422l-.473-1.371h-2.231l-.575-1.59h2.295l-1.362-4.077-1.154 3.451-.879-2.498.921-2.493h2.222l3.033 8.516c.111.315.244.484.578.484h.469zm-6-1h1v2h-7v-2h.532c.459 0 .782-.453.633-.887l-.816-2.113h-6.232l-.815 2.113c-.149.434.174.887.633.887h1.065v2h-7v-2h.43c.593 0 1.123-.375 1.32-.935l5.507-15.065h3.952l5.507 15.065c.197.56.69.935 1.284.935zm-10.886-6h4.238l-2.259-6.199-1.979 6.199z" />
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "table" || icon.toLowerCase() === "tabular") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline transition duration-100 " + colorClass + sizeClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M19 14.586l3.586-3.586 1.414 1.414-3.586 3.586 3.586 3.586-1.414 1.414-3.586-3.586-3.586 3.586-1.414-1.414 3.586-3.586-3.586-3.586 1.414-1.414 3.586 3.586zm-7 6.414h-12v-2h12v2zm0-4.024h-12v-2h12v2zm0-3.976h-12v-2h12v2zm12-4h-24v-2h24v2zm0-4h-24v-2h24v2z" />
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "image") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline transition duration-100 " + colorClass + sizeClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M9 12c0-.552.448-1 1.001-1s.999.448.999 1-.446 1-.999 1-1.001-.448-1.001-1zm6.2 0l-1.7 2.6-1.3-1.6-3.2 4h10l-3.8-5zm5.8-7v-2h-21v15h2v-13h19zm3 2v14h-20v-14h20zm-2 2h-16v10h16v-10z" />
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "tryme") {
    return (
      <span>
        <svg width="60px" height="44px" viewBox="0 0 60 44" version="1.1">
          <title>tryme</title>
          <g
            id="Handtrack.js"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="tryme" transform="translate(0.275948, 0.000000)">
              <text
                id="Try-me! "
                // fontFamily="NeuePlakText-Regular, Neue Plak Text"
                fontSize="13"
                fontWeight="normal"
                letterSpacing="-0.291836735"
                fill="currentColor"
              >
                <tspan x="0.724052146" y="16">
                  Try me!
                </tspan>
              </text>
              <path
                id="Path-2"
                d="M45.6308698,12.3846691 C47.0714497,12.3846691 47.9527129,12.7538047 48.3630064,13.5363467 C48.6635301,14.1095279 48.6723749,14.5959454 48.5458179,15.8718124 C48.512627,16.2064213 48.4976169,16.3784204 48.4868888,16.5728325 C48.4329337,17.550591 48.5897008,18.1615014 49.0974801,18.633936 C49.569609,19.0732016 50.4145705,19.0726406 51.8480108,18.698411 C52.0454151,18.6468744 52.2436808,18.5918202 52.5280317,18.5105178 C55.1034698,17.7741413 55.8069484,17.7097165 56.2602694,18.809449 C56.7777601,20.0648532 56.3868707,20.962711 54.897811,23.1064864 C53.6115061,24.958359 53.2739116,25.8016041 53.6805938,26.7396299 C53.8196564,27.0603826 54.174522,27.2227716 55.1715847,27.4467776 C55.6274825,27.5492023 55.5789063,27.5381676 55.7278594,27.5745628 C56.8992519,27.8607805 57.6263946,28.242916 58.1173777,29.030913 C58.7008893,29.9674126 58.7200429,31.46896 58.1454128,32.6899182 C57.2933548,34.5003475 55.3015804,36.4766591 52.1703505,38.6485638 L54.2220598,42.1210778 L44.1844807,42.8260641 L49.643039,34.373009 L51.6601704,37.785333 C54.6238305,35.7220387 56.4838925,33.8719397 57.2406116,32.2640838 C57.67738,31.3360505 57.6627906,30.1923141 57.2686468,29.559738 C56.9501791,29.0486174 56.4310467,28.7757976 55.4905024,28.5459852 C55.350798,28.5118499 55.3978691,28.5225427 54.9523827,28.4224571 C53.6345694,28.1263893 53.0823224,27.8736772 52.763111,27.1374055 C52.1605997,25.747693 52.5890917,24.6774038 54.0764997,22.5360062 C55.3516869,20.7001395 55.6631251,19.9847781 55.3357365,19.190551 C55.2115612,18.8893085 54.6661323,18.9392591 52.8029382,19.4719888 C52.5117886,19.5552351 52.3070628,19.6120831 52.1006152,19.6659806 C50.3508979,20.122781 49.2304427,20.1235249 48.416313,19.366064 C47.6476517,18.6509065 47.4197111,17.7626376 47.4884079,16.517734 C47.5001822,16.3043633 47.5161209,16.1217226 47.5507015,15.7731039 C47.655571,14.7158759 47.6485021,14.327122 47.4773565,14.0007004 C47.2852729,13.6343443 46.8076479,13.4152212 45.8447138,13.387633 L45.6308698,13.3846691 L45.6308698,12.3846691 Z"
                fill="currentColor"
                fillRule="nonzero"
              ></path>
            </g>
          </g>
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "github") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline  transition duration-100 " + colorClass + sizeClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "npm") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline  transition duration-100 " + colorClass + sizeClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 256 150"
        >
          <path
            d="M42.502 14.332h-28.17v56.834h28.17V28.664h14.332v42.502h14.332V14.332H42.502zM85.498 14.332v71.166h28.664V71.166h28.17V14.332H85.498zM128 56.834h-13.838v-28.17H128v28.17zM184.834 14.332h-28.17v56.834h28.17V28.664h14.332v42.502h14.332V28.664h14.332v42.502h14.332V14.332h-57.328z"
            fill="#FFF"
          />
        </svg>
      </span>
    );
  }
  if (icon.toLowerCase() === "twitter") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline  transition duration-100 " + colorClass + sizeClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.066 9.645c.183 4.04-2.83 8.544-8.164 8.544-1.622 0-3.131-.476-4.402-1.291 1.524.18 3.045-.244 4.252-1.189-1.256-.023-2.317-.854-2.684-1.995.451.086.895.061 1.298-.049-1.381-.278-2.335-1.522-2.304-2.853.388.215.83.344 1.301.359-1.279-.855-1.641-2.544-.889-3.835 1.416 1.738 3.533 2.881 5.92 3.001-.419-1.796.944-3.527 2.799-3.527.825 0 1.572.349 2.096.907.654-.128 1.27-.368 1.824-.697-.215.671-.67 1.233-1.263 1.589.581-.07 1.135-.224 1.649-.453-.384.578-.87 1.084-1.433 1.489z" />
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "rightarrow") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline  transition duration-100 " + colorClass + sizeClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M6.028 0v6.425l5.549 5.575-5.549 5.575v6.425l11.944-12z" />
        </svg>
      </span>
    );
  }

  if (icon.toLowerCase() === "rocket") {
    return (
      <span>
        <svg
          aria-hidden="true"
          className={
            " mr-1 inline h-6 w-6  transition duration-100 " + colorClass
          }
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M8.566 17.842c-.945 2.462-3.678 4.012-6.563 4.161.139-2.772 1.684-5.608 4.209-6.563l.51.521c-1.534 1.523-2.061 2.765-2.144 3.461.704-.085 2.006-.608 3.483-2.096l.505.516zm-1.136-11.342c-1.778-.01-4.062.911-5.766 2.614-.65.649-1.222 1.408-1.664 2.258 1.538-1.163 3.228-1.485 5.147-.408.566-1.494 1.32-3.014 2.283-4.464zm5.204 17.5c.852-.44 1.61-1.013 2.261-1.664 1.708-1.706 2.622-4.001 2.604-5.782-1.575 1.03-3.125 1.772-4.466 2.296 1.077 1.92.764 3.614-.399 5.15zm11.312-23.956c-.428-.03-.848-.044-1.261-.044-9.338 0-14.465 7.426-16.101 13.009l4.428 4.428c5.78-1.855 12.988-6.777 12.988-15.993v-.059c-.002-.437-.019-.884-.054-1.341zm-5.946 7.956c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z" />
        </svg>
      </span>
    );
  }

  return (
    <span>
      <svg
        aria-hidden="true"
        className="mr-1 inline h8 w-8 transition duration-100 "
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M12.819 14.427c.064.267.077.679-.021.948-.128.351-.381.528-.754.528h-.637v-2.12h.496c.474 0 .803.173.916.644zm3.091-8.65c2.047-.479 4.805.279 6.09 1.179-1.494-1.997-5.23-5.708-7.432-6.882 1.157 1.168 1.563 4.235 1.342 5.703zm-7.457 7.955h-.546v.943h.546c.235 0 .467-.027.576-.227.067-.123.067-.366 0-.489-.109-.198-.341-.227-.576-.227zm13.547-2.732v13h-20v-24h8.409c4.858 0 3.334 8 3.334 8 3.011-.745 8.257-.42 8.257 3zm-12.108 2.761c-.16-.484-.606-.761-1.224-.761h-1.668v3.686h.907v-1.277h.761c.619 0 1.064-.277 1.224-.763.094-.292.094-.597 0-.885zm3.407-.303c-.297-.299-.711-.458-1.199-.458h-1.599v3.686h1.599c.537 0 .961-.181 1.262-.535.554-.659.586-2.035-.063-2.693zm3.701-.458h-2.628v3.686h.907v-1.472h1.49v-.732h-1.49v-.698h1.721v-.784z" />
      </svg>
    </span>
  );
};

export default Icons;
